const handlerIntersection = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('active');
    } else {
      entry.target.classList.remove('active');
    }
  });
};

const initSpiritAnimation = () => {
  const wrapper = document.querySelector('.js-spirit');

  if (!wrapper) {
    return;
  }

  const animationObserver = new IntersectionObserver(handlerIntersection);
  animationObserver.observe(wrapper);
};

export {initSpiritAnimation};
